var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4ChildSafety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 65h14v4H3V7h18v4H7v54zM55 7v4h14v54H55v4h18V7H55zm5.7 23.93A5.5 5.5 0 1053 30a5.51 5.51 0 007.7.93zm-5.7 7c.005-.1.005-.2 0-.3A6 6 0 0049 32H30a6 6 0 00-6 6v11h-9.15a3.1 3.1 0 00-3.1 2.44A3 3 0 0014.7 55h13.69a3 3 0 00.73-.1 5 5 0 004.89-5V44H49v8.79a3.1 3.1 0 002.44 3.1A3 3 0 0055 52.94V37.93z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Child_safety.88b8579b.svg";
export { SvgA4ChildSafety as ReactComponent };